import { EVENT_TYPES } from '../component/MatomoTagManger/MatomoTagManager.events';
import { pushEvent } from '../store/Matomo/Matomo.action';

const componentDidUpdate = (args, callback, instance) => {
    const { firedMtm = false } = instance.state;
    const { product: { price_range, variants }, pushEvent, product } = instance.props;

    if (price_range?.minimum_price && variants?.length && !firedMtm) {
        pushEvent(EVENT_TYPES.PRODUCT_VIEW, product);
        instance.setState({ firedMtm: true });
    }

    return callback.apply(instance, args);
};

const mapDispatchToProps = (args, callback) => {
    const [dispatch] = args;

    return {
        ...callback(...args),
        pushEvent: (event, data) => {
            dispatch(pushEvent(event, data));
        }
    };
};

export default {
    'Route/ProductPage/Container': {
        'member-function': {
            componentDidUpdate
        }
    },
    'Route/ProductPage/Container/mapDispatchToProps': {
        function: mapDispatchToProps
    }
};
